import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { themeStore } from "@/stores";
import { router } from "@/app/routes";
import { ErrorBoundary, FullPageError } from "@/components/error";
import { AppLoading } from "@/components/common";
import { useAuthStore } from "@/features/auth/hooks";
import {
  SessionExpiredDialog,
  SessionWarningDialog,
} from "@/features/auth/components";

const App = observer(() => {
  const { bootstrap, bootstrapping } = useAuthStore();

  useEffect(() => {
    // Initialize theme on mount
    themeStore.initializeTheme();
  }, []);

  useEffect(() => {
    bootstrap();
  }, []);

  if (bootstrapping) {
    return <AppLoading />;
  }

  return (
    <ErrorBoundary fallback={FullPageError}>
      {/* Toast notifications */}

      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          closeButtonButtonStyle: {
            background: "#fff",
            color: "#000",
            border: "1px solid #ccc",
          },
        }}
      />

      {/* Session warning dialog */}
      <SessionWarningDialog />
      <SessionExpiredDialog />

      {/* Router */}
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
});

export default App;
